import { Component } from 'react';
import { ErrorFallback } from '@/pages/ErrorPage/ErrorFallback';

/**
 * Top-level error boundary. Catches render-time errors anywhere in the React
 * tree (outside react-router's route-level handling) and shows the branded
 * fallback instead of a white screen (AUT-180).
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught render error:', error, info);
  }

  render() {
    if (this.state.hasError) return <ErrorFallback />;
    return this.props.children;
  }
}
